import dynamic from 'next/dynamic'
import type { ComponentType } from 'react'

const blocks: Record<string, ComponentType<any>> = {
  Basic: dynamic(() => import('./Basic')),
  HubspotForm: dynamic(() => import('./HubspotForm')),
  CallToAction: dynamic(() => import('./CallToAction')),
  Dift: dynamic(() => import('./Dift')),
  Features: dynamic(() => import('./Features')),
  Hero: dynamic(() => import('./Hero')),
  HeroDift: dynamic(() => import('./HeroDift')),
  Video: dynamic(() => import('./Video')),
  Logos: dynamic(() => import('./Logos')),
  PercentData: dynamic(() => import('./PercentData')),
  Quotes: dynamic(() => import('./Quotes')),
  UseCases: dynamic(() => import('./UseCases')),
  ZigZag: dynamic(() => import('./ZigZag')),
  BigQuote: dynamic(() => import('./BigQuote')),
  LargeImageHero: dynamic(() => import('./LargeImageHero')),
  ZigZagCheck: dynamic(() => import('./ZigZagCheck')),
  Products: dynamic(() => import('./Products')),
  TenMillions: dynamic(() => import('./TenMillions')),
  Flow: dynamic(() => import('./Flow')),
  Faq: dynamic(() => import('./Faq')),
}

export default blocks
